export default "/profile/images/NetHunt.svg?64da78797c85c3e042cedc261e4e9d5d";